<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title class="justify-center">
          Seguro que quieres eliminar este producto
        </v-card-title>

        <v-divider></v-divider>
        <br />

        <v-card-text class="text-center">
          <div>
            <v-btn
              @click="cancel"
              color="light"
              text
              style="margin-top: 5px; height: 50px; width: 50px;font-size: 50px"
            >
              <font-awesome-icon
                icon="times-circle"
                :style="{ color: '#ea2222', fontSize: 50 }"
              />
            </v-btn>

            <v-btn
              @click="deleteDrinks"
              color="light"
              text
              v-if="isTypeDrinks"
              style="margin-top: 5px; height: 50px; width: 50px;font-size: 50px;"
            >
              <font-awesome-icon
                icon="check-circle"
                :style="{ color: '#11bd11', fontSize: 50 }"
              />
            </v-btn>

            <v-btn
              @click="deleteFood"
              color="light"
              text
              v-if="isTypeFood"
              style="margin-top: 5px; height: 50px; width: 50px;font-size: 50px;"
            >
              <font-awesome-icon
                icon="check-circle"
                :style="{ color: '#11bd11', fontSize: 50 }"
              />
            </v-btn>

            <v-btn
              @click="deleteDessert"
              color="light"
              text
              v-if="isTypeDessert"
              style="margin-top: 5px; height: 50px; width: 50px;font-size: 50px;"
            >
              <font-awesome-icon
                icon="check-circle"
                :style="{ color: '#11bd11', fontSize: 50 }"
              />
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "delete-dialog",
  props: ["dialog", "isTypeDrinks", "isTypeFood", "isTypeDessert"],
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    deleteDrinks() {
      this.$emit("deleteDrinks");
    },
    deleteFood() {
      this.$emit("deleteFood");
    },
    deleteDessert() {
      this.$emit("deleteDessert");
    }
  }
};
</script>

<style scoped lang="scss"></style>
